import registry from "content/pages.registry.json";
import { galleryFromJson } from "hooks/useGallery";
import ImageGrid from "components/imagegrid";

const contentContext = require.context("../../content", true, /\.json$/);

function loadGalleryJson(slug) {
  const entry = registry[slug];
  if (!entry) {
    console.warn(`No registry entry for page slug "${slug}"`);
    return null;
  }

  const contentKey = `./${entry.content}`;
  try {
    const mod = contentContext(contentKey);
    return mod.default ?? mod;
  } catch (error) {
    console.warn(`Missing gallery content for "${slug}" at ${entry.content}`);
    return null;
  }
}

const PageGallery = ({ slug, maxWidth = "900" }) => {
  const galleryJson = loadGalleryJson(slug);
  if (!galleryJson) {
    return null;
  }

  const imageData = galleryFromJson(galleryJson);
  if (imageData.length === 0) {
    return null;
  }

  return <ImageGrid imageData={imageData} maxWidth={maxWidth} />;
};

export default PageGallery;
